module.exports = __webpack_public_path__ + "img/img80.98cae0d2.png";